import React, { useState } from "react";
import Swal from "sweetalert2";
import LicenciaSelect from "./LicenciaSelect";
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import axios from 'axios';
import InfoCadete from "../tools/InfoCadete";

const CarpetaExaminaForm = ({ cadete, onClose }) => {
  const [formData, setFormData] = useState('');
  const [valor, setValor] = useState('');
  const Usuario = ObtieneDatosCookies()
  
  const handleChange = (e) => {
    const inputValue = e.target.value;

    // Solo permitimos letras (de la A a la Z, mayúsculas o minúsculas)
    if (/^[A-Za-z]*$/.test(inputValue)) {
      setValor(inputValue);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Validar solo letras para el campo cadeteDomicilio
    if (name === "cadeteDomicilio" && !/^[A-Za-z\s]*$/.test(value)) {
      return; // Si no cumple con el patrón, no actualizamos el estado
    }

    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const today = new Date();
const generaNuevoReconocimiento=async()=>{
 
const reconocimientoMedico={

  finalizaCondicion:formData.finalizaCondicion,
  iniciaCondicion:formData.iniciaCondicion,
  medicoReviso:Usuario.nombre + " "+Usuario.apellido,
  diagnostico:formData.diagnostico,
  tipoDiagnostico:formData.tipoDiagnostico,
  otorgaPaseSalida:formData.otorgaPaseSalida,
  estado:"Diagnosticado"
}

try {
if(reconocimientoMedico.tipoDiagnostico=="Actividad Normal"||reconocimientoMedico.finalizaCondicion>=reconocimientoMedico.iniciaCondicion){
  const username = process.env.REACT_APP_KEY; 
    const password = process.env.REACT_APP_PASS; 
    const token = btoa(`${username}:${password}`);

    const response = await axios.post(
      `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaCarpetaMedica/${cadete.id}`,
      reconocimientoMedico,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    if(response){
      
      onClose();
    
  }
}else{alert("No puede ser la fecha de regreso antes de la fecha de inicio de la carpeta")}
   }catch{

  }




}

  const handleReempadronar = () => {
    const { diagnostico,tipoDiagnostico,finalizaCondicion,iniciaCondicion } = formData;
    const formControls = document.querySelectorAll(".form-control");
    const hasInvalidFields = Array.from(formControls).some((input) =>
      input.classList.contains("is-invalid")
    );

    if (hasInvalidFields) {
      Swal.fire({
        title: "Error",
        text: "Por favor, corrige los campos en rojo.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }
    if (!diagnostico||!tipoDiagnostico) {
      if(!tipoDiagnostico=="Actividad Normal"&&!iniciaCondicion||!tipoDiagnostico=="Actividad Normal"&&finalizaCondicion){
      Swal.fire({
        title: "Error",
        text: "Por favor, completa todos los campos requeridos.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }}

    Swal.fire({
      title: "¿Estás seguro?",
      text: "Vas a Generar un nuevo Reconocimiento Medico para el cadete.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, generar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
       generaNuevoReconocimiento()
        
      }
    });
  };

  const handleCancel = () => {

    onClose();


  };


  const handleIniciaCondicion = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset()); // Ajuste de zona horaria
    const formattedDate = now.toISOString().slice(0, 16);
    setFormData({ ...formData, iniciaCondicion: formattedDate });
  };

  const handleFinalizaCondicion = (e) => {
    const selectedDate = new Date(e.target.value);
    
    const argentinaOffset = 3 * 60; 
    
    const utcDate = new Date(selectedDate.getTime() + (selectedDate.getTimezoneOffset() * 60000)); 
    utcDate.setHours(5, 30, 0, 0);
    
    const argentinaDate = new Date(utcDate.getTime() - (argentinaOffset * 60000));  
    
    const formattedDate = argentinaDate.toISOString().slice(0, 16);
    
    if (formData.iniciaCondicion && new Date(formData.iniciaCondicion) >= argentinaDate) {
      alert('La fecha de inicio no puede ser igual o posterior a las 05:30 AM de Argentina.');
      return; 
    }
  
    setFormData({ ...formData, finalizaCondicion: formattedDate });
  };
  
  const handleAnular=async()=>{
    try{
    const username = process.env.REACT_APP_KEY; 
    const password = process.env.REACT_APP_PASS; 
    const token = btoa(`${username}:${password}`);

    const response = await axios.post(
      `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaCarpetaMedica/${cadete.id}`,
      {estado:"Suspendido"},
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    if(response){
      
      onClose();
    
  
}else{alert("Algo fallo contacte a DTyD")}
}catch{

  }
}
  return (
    <div style={{  width: "580px", overflow: "auto", margin: "0 auto", maxHeight: "480px",}}
    >

      <div>


        <div className="d-flex justify-content-center gap-3 mb-3">
          <img
            src={`https://wwwa.isepsantafe.net.ar/imagenes/${cadete.cadete.fotoCadete}`}
            alt="Foto Cadete"
            className="rounded-circle border"
            style={{ height: "90px", width: "90px", cursor: "pointer" }}

          />
   <button className='btn btn-primary'onClick={()=>InfoCadete(cadete.cadeteDni)}>Info Cadete</button>
        </div>
      </div>
      <form style={{ textAlign: "center" }}>
     <div style={{display:"flex",alignItems:"center",flexDirection:"column",textAlign:"center",border:"1px grey solid" }}>
   
     <h5 htmlFor="">Motivo</h5>
<textarea 
  name="" 
  id="" 
  value={cadete.motivoSolicitud} 
  disabled 
  readOnly 
  style={{ resize: "none",textAlign:"center", width:"100%" }}
/>

     </div>
        <div className="input-group-text" style={{ display: "flex", width: "100%",justifyContent: "space-around" }}>

          <div style={{width:"550px"}}>
            <label>Diagnostico y Tratamiento</label>
            <textarea
              name="diagnostico"
              value={formData.diagnostico || ""}
              onChange={handleInputChange}
              required
              minLength={12}
              className={`form-control ${!formData.diagnostico || formData.diagnostico.length < 12 ? "is-invalid" : "is-valid"}`}
              rows="4" // Ajusta la cantidad de filas visibles
            />
          </div></div>
          <div className="input-group-text" style={{ display: "flex", width: "100%",justifyContent: "space-around", flexDirection:"column" }}>
          <div className="">
            <label>Aconseja</label>
          
            <select
              name="tipoDiagnostico"
              value={formData.tipoDiagnostico || ""}
              onChange={handleInputChange}
              required
              className={`form-select ${!formData.tipoDiagnostico ? "is-invalid" : "is-valid"
                }`}
            >
              <option value="">Seleccionar...</option>
              <option value="Actividad Normal">Actividad Normal</option>
              <option value="Exceptuado">Exceptuado</option>
              <option value="Consulta Externa">Consulta Externa</option>
              <option value="Reposo Compañia">Reposo en Compañia</option>
              <option value="Reposo Domicilio">Reposo en Domicilio</option>
              <option value="LTB">LTB</option>
             

            </select>
          </div></div>
      <div className="input-group-text" style={{ display: "flex", width: "100%",justifyContent: "space-around", flexDirection:"column" }}>
{formData.tipoDiagnostico=="Actividad Normal"||formData.tipoDiagnostico=="LTB"?"":<>




  <div style={{ display: "flex", flexDirection: "column", gap: "12px"}}>
      {/* Inicia Condición */}
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <label>Inicia Condición</label>
        <input
          type="datetime-local"
          name="iniciaCondicion"
          value={formData.iniciaCondicion}
          onFocus={handleIniciaCondicion} // Se asigna la hora actual al enfocarse
          readOnly
          style={{
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "5px",
          }}
          className={`form-control ${!formData.iniciaCondicion? "is-invalid" : "is-valid"}`}
        />
      </div>

      {/* Finaliza Condición */}
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <label>Finaliza Condición</label>
        <input
          type="date"
          name="finalizaCondicion"
          onChange={handleFinalizaCondicion}
          className={`form-control ${!formData.finalizaCondicion? "is-invalid" : "is-valid"}`}
          style={{
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            
          }}
        />
        {formData.finalizaCondicion && (
          <p style={{ margin: "5px 0", fontSize: "14px", color: "#555" }}>
            Se finalizará el:{" "}
            <strong>
              {new Date(formData.finalizaCondicion).toLocaleString()}
            </strong>
          </p>
        )}
      </div>
    </div>
   <div>{formData.tipoDiagnostico=="Exceptuado"?<></>:   <div style={{ display: "flex", flexDirection: "column", gap: "8px"}}>
  <label>Otorga Pase de Salida</label>
  
  <div style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent:"center",  alignItems:"center" }}>
    <span>No</span>
    <label 
      style={{ 
        position: "relative", 
        display: "inline-block", 
        width: "50px", 
        height: "25px" 
      }}
    >
      <input
        type="checkbox"
        name="otorgaPaseSalida"
        checked={formData.otorgaPaseSalida === "SI"}
        onChange={(e) =>
          setFormData({
            ...formData,
            otorgaPaseSalida: e.target.checked ? "SI" : "NO",
          })
        }
        style={{ display: "none" }}
      />
      <span
        style={{
          position: "absolute",
          cursor: "pointer",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          backgroundColor: formData.otorgaPaseSalida === "SI" ? "#4CAF50" : "#ccc",
          transition: "0.3s",
          borderRadius: "25px",
        }}
      ></span>
      <span
        style={{
          position: "absolute",
          content: '""',
          height: "20px",
          width: "20px",
          left: "4px",
          bottom: "2.5px",
          backgroundColor: "white",
          transition: "0.3s",
          borderRadius: "50%",
          transform: formData.otorgaPaseSalida === "SI" ? "translateX(25px)" : "translateX(0)",
        }}
      ></span>
    </label>
    <span>Si</span>
  </div>
</div>}

   </div>
</>}
</div>


        <div className="">
          <button
            type="button"
            className="btn btn-primary me-2"
            onClick={handleReempadronar}
          >
            Completa Examen
          </button>
         {Usuario.destino==7||Usuario.destino==2? <button
            type="button"
            className="btn btn-warning me-2"
            onClick={handleAnular}
          >
            Anular Carpeta Medica
          </button>:""} 
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleCancel}
          >
            Cancelar
          </button>
        </div>
      </form>

    </div>
  );
};

export default CarpetaExaminaForm;
